/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core'
import { RootState, selectFocusedSecurities } from '@helios/state-management'
import { Store } from '@ngrx/store'
import { Observable, Subject } from 'rxjs'
import { distinctUntilChanged, map, takeUntil } from 'rxjs/operators'

@Component({
  selector: 'hs-securities-selected',
  templateUrl: './securities-selected.component.html',
  styleUrls: ['./securities-selected.component.scss'],
})
export class SecuritiesSelectedComponent implements OnInit, OnDestroy {
  private readonly _destroyed$ = new Subject<void>()

  @Input() content: TemplateRef<any> | null = null
  @Output() securitySelectionChange = new EventEmitter<number[]>()

  selectedSecurities$: Observable<number[]> = this.store
    .select(selectFocusedSecurities)
    .pipe(
      distinctUntilChanged(
        // Don't produce if the array is reordered
        (a, b) => a.length == b.length && a.every(x => b.includes(x)),
      ),
    )

  areAllSecuritiesSame$ = this.selectedSecurities$.pipe(
    map(securities => {
      if (securities.length == 1) return true
      else if (securities.length > 1) {
        const firstSecurity = securities[0]
        return securities.every(x => x === firstSecurity)
      } else return undefined
    }),
    distinctUntilChanged(),
  )

  constructor(private readonly store: Store<RootState>) {}

  ngOnInit() {
    this.selectedSecurities$
      .pipe(takeUntil(this._destroyed$))
      .subscribe(securities => this.securitySelectionChange.emit(securities))
  }

  ngOnDestroy() {
    this._destroyed$.next()
    this._destroyed$.complete()
  }
}
